import { Component, EventEmitter, forwardRef, HostBinding, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter, map, startWith, switchMap, tap } from 'rxjs/operators';
import { CommonService } from '../../../core/services/v2/common.service';

@Component({
  selector: 'app-dynamic-autocomplete',
  templateUrl: './dynamic-autocomplete.component.html',
  styleUrls: ['./dynamic-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DynamicAutocompleteComponent),
      multi: true
    }
  ]
})
export class DynamicAutocompleteComponent implements OnInit, ControlValueAccessor {

  myControl = new FormControl();
  selectedValue;
  filteredOptions: Observable<any[]>;
  @Input() apiUrl: string;


  constructor(private commonService: CommonService) { };

  // Function to call when the option changes.
  onChange = (option: string) => { };

  // Function to call when the input is touched (when the autocomplete is clicked).
  onTouched = () => { };

  get value() {
    return this.selectedValue;
  }

  ngOnInit() {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((val) => {
        return this.filter(val || '');
      })
    );
    //this.filteredOptions = this.myControl.valueChanges
    //  .pipe(
    //    startWith(''),
    //    map(option => this.filter(option))
    //  );
  }

  optionSelected(option) {
    //this.myControl.setValue(option.value);
    this.writeValue(option.value);
  }

  // Allows Angular to update the model (option).
  // Update the model and changes needed for the view here.
  writeValue(option: string): void {
    this.selectedValue = option;
    if (this.selectedValue != null) {
      this.myControl.setValue(this.selectedValue);
    }
    this.onChange(option);
  }

  // Allows Angular to register a function to call when the model (rating) changes.
  // Save the function as a property to call later here.
  registerOnChange(fn: (option: string) => void): void {
    this.onChange = fn;
  }

  // Allows Angular to register a function to call when the input has been touched.
  // Save the function as a property to call later here.
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  enter() {
    const controlValue = this.myControl.value;
    this.writeValue(controlValue);
  }

  private filter(value: string): Observable<any[]> {
    return this.commonService.getDynamicSearchApiData(this.apiUrl).pipe(
      tap(),
      map((response) => response)
    );
    //this.commonService.getDynamicSearchApiData(value, this.apiUrl).subscribe(
    //  (details) => {
    //    return details;
    //  },
    //  (error) => { console.error(error); }
    //);
  }
}
